import {
  createContext,
  FC,
  PropsWithChildren,
  useCallback,
  useContext,
  useState,
} from 'react';

type PanelState = {
  showFilterPanel: boolean;
  showSidePanel: boolean;
  isSinglePaneView: boolean;
  toggleFilterPanel: (val?: boolean) => void;
  toggleSidePanel: (val?: boolean) => void;
};

const PanelContext = createContext<PanelState>({
  showFilterPanel: false,
  showSidePanel: false,
  isSinglePaneView: false,
  toggleFilterPanel: () => {
    throw new Error('Context not provided.');
  },
  toggleSidePanel: () => {
    throw new Error('Context not provided.');
  },
});

export const usePanel = () => {
  return useContext(PanelContext);
};

export const PanelProvider: FC<PropsWithChildren<{ isSinglePaneView: boolean }>> = ({
  isSinglePaneView: _isSinglePaneView,
  children,
}) => {
  const [showFilterPanel, updateShowFilterPanel] = useState<boolean>(false);
  const [showSidePanel, updateShowSidePanel] = useState<boolean>(false);
  const [isSinglePaneView] = useState<boolean>(_isSinglePaneView);

  return (
    <PanelContext.Provider
      value={{
        showFilterPanel,
        showSidePanel,
        toggleFilterPanel: useCallback((val?: boolean) => {
          updateShowFilterPanel(val === undefined ? (prev) => !prev : val);
        }, []),
        toggleSidePanel: useCallback((val?: boolean) => {
          updateShowSidePanel(val === undefined ? (prev) => !prev : val);
        }, []),
        isSinglePaneView,
      }}
    >
      {children}
    </PanelContext.Provider>
  );
};
